export default __webpack_public_path__ + "static/media/in_out.0f23602a.png";